import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

/**
 * Share-of-total chart.
 *
 * Renders a doughnut rather than a full pie: the hole gives the centre back for
 * a total, and comparing arc lengths on a ring is easier than comparing wedge
 * areas.
 *
 * A doughnut is an all-pairs form — any two segments can end up adjacent — so
 * callers must cap it at 4 slices (see `capSeries` in helpers/chartTheme.js)
 * and ship a labelled legend. Colour alone never identifies a segment.
 */
const PieCharts = ({ data, options }) => {
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <Doughnut data={data} options={options} />
        </div>
    );
};

export default PieCharts;
